import React from "react";

const TabButton = ({ text, active, onClick }) => (
  <button
    onClick={onClick}
    className={`px-4 py-2 mr-4 text-[12px] sm:text-[16px] font-semibold whitespace-nowrap relative transition duration-200 ease-in-out focus:outline-none ${
      active ? "text-orange-500" : "text-white hover:text-gray-200"
    }`}
  >
    {text}
    {active && (
      <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-orange-500"></span>
    )}
  </button>
);

export default TabButton;
